// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__SIm8K","subHeading":"Home_subHeading__WmO8P","tabs":"Home_tabs__38WZT"};